"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageQuery = void 0;
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _utils_1 = require("@utils");
const _layouts_1 = require("@layouts");
// ContentfulDestination
var InfoPageTemplate = function InfoPageTemplate(_ref) {
    var _body$childMarkdownRe;
    var title = _ref.title, body = _ref.body;
    return /*#__PURE__*/ react_1.default.createElement(_layouts_1.NavLayout, null, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "layoutBorder"
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SectionHeader, {
        title: title,
        small: true,
        ruleBottom: true,
        fullWidth: true,
        halfPadding: true
    }), /*#__PURE__*/ react_1.default.createElement(Article, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.ArticleBody, {
        articleBody: (body === null || body === void 0 ? void 0 : (_body$childMarkdownRe = body.childMarkdownRemark) === null || _body$childMarkdownRe === void 0 ? void 0 : _body$childMarkdownRe.html) || "",
        hasDropCap: false
    }))));
}; // Styling
var Article = styled_components_1.default.article.withConfig({
    displayName: "infoPage__Article",
    componentId: "sc-1sc6grg-0"
})([""]); // Data
var mapDataToProps = function mapDataToProps(_ref2) {
    var contentfulInfoPage = _ref2.contentfulInfoPage;
    return Object.assign({}, contentfulInfoPage);
};
exports.default = _utils_1.WithData(mapDataToProps, InfoPageTemplate);
exports.pageQuery = "3814983086";
